import {PhoneNumber} from './PhoneNumber';

export type ContactPerson = {
  firstName: string | null;
  lastName: string | null;
  role: string | null;
  isPrimary: boolean | null;
  phoneNumber: PhoneNumber | null;
  emailAddress: string | null;
};
